import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import { SolidButton } from '@/components/Button';
import GrayOutlineButton from '@/components/Button/OutlineButton.gray';
import ComposableProjectHeader from '@/components_cards/ComposableProjectHeader';
import DividerCard from '@/components/DividerCard';
import TagRow from '@/components_cards/tags/TagRow';
import ProjectTag from '@/components_cards/tags/ProjectTag';
import HiddenTag from '@/components_cards/tags/_resource/HiddenTag';
import Questions from '@/pages/my-past/ProjectCreated/Questions';

ActiveProject.propTypes = {
  project: PropTypes.object.isRequired
};

export default function ActiveProject(props) {
  const { project: theProject } = props;
  const project = useConnect('project.byId', {
    id: theProject?.data?.id
  }, { enabled: !!theProject?.data?.id});

  const launch = useDialogLauncher();

  function onClickManage() {
    launch(DialogManager.ProjectManage.Config(project.id, `/manage`));
  }

  function onClickClose() {
    launch(DialogManager.ProjectClose.Config(project.id));
  }

  if (project.state !== PayloadStates.RESOLVED) return null;

  return (
    <DividerCard>
      <ComposableProjectHeader
        project={project}
        tags={(
          <>
            <TagRow>
              <ProjectTag />
              <HiddenTag resource={project} />
              {/*more tags were here prior to 94b6a824 */}
            </TagRow>
            <Questions project={project} />
          </>
        )}
        showTags={false}
        showCreator={false}
      />
      <div className="w-full bg-cs-gray-50 py-4 px-4 flex justify-between items-center flex-wrap gap-2">
        <div className="flex flex-wrap gap-2">
          {/* more buttons were here prior to 94b6a824 */}
        </div>
        <div className="flex flex-wrap gap-2">
          <GrayOutlineButton
            onClick={onClickClose}
            label="Close project"
          />
          <SolidButton
            onClick={onClickManage}
            label="Coordinate project"
          />
        </div>
      </div>
    </DividerCard>
  );
}
